import { Observable } from 'rxjs';

import { MgmtDept } from '../models/mgmt-dept.model';

export abstract class MgmtDeptUsecase {
  abstract get mgmtDept$(): Observable<MgmtDept>;
}
